import { EntityTemplateVariables } from '@tools/interfaces/template';

export const templateOrder: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.orders.code.label',
      contentValue: '{{ order.code }}',
      description: 'templates.orders.code.description',
    },
    {
      label: 'templates.orders.type.label',
      contentValue: '{{ order.type }}',
      description: 'templates.orders.type.description',
    },
    {
      label: 'templates.orders.date.label',
      contentValue: '{{ order.date | date("d/m/Y") }}',
      description: 'templates.orders.date.description',
    },
    {
      label: 'templates.orders.total_price.label',
      contentValue: '{{ order.total_price }}',
      description: 'templates.orders.total_price.description',
    },
    {
      label: 'templates.orders.paid.label',
      contentValue: '{{ order.paid }}',
      description: 'templates.orders.paid.description',
    },
    {
      label: 'templates.orders.balance.label',
      contentValue: '{{ order.balance }}',
      description: 'templates.orders.balance.description',
    },
    {
      label: 'templates.orders.status.label',
      contentValue: '{{ order.status }}',
      description: 'templates.orders.status.description',
    },
    {
      label: 'templates.orders.total_tax.label',
      contentValue: '{{ order.total_tax }}',
      description: 'templates.orders.total_tax.description',
    },
    {
      label: 'templates.orders.description.label',
      contentValue: '{{ order.description }}',
      description: 'templates.orders.description.description',
    },
    // {
    //   label: 'templates.orders.timer.label',
    //   contentValue: '{{ order.timer }}',
    //   description: 'templates.orders.timer.description',
    // },
    // {
    //   label: 'templates.orders.current.label',
    //   contentValue: '{{ order.current }}',
    //   description: 'templates.orders.current.description',
    // },
  ],
  related: [],
  relatedInLoop: [],
};
export const templateOrderItem: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.order_items.code.label',
      contentValue: '{{ orderItem.code }}',
      description: 'templates.order_items.code.description',
    },
    {
      label: 'templates.order_items.article_name.label',
      contentValue: '{{ orderItem.article_name }}',
      description: 'templates.order_items.article_name.description',
    },
    {
      label: 'templates.order_items.quantity.label',
      contentValue: '{{ orderItem.quantity }}',
      description: 'templates.order_items.quantity.description',
    },
    {
      label: 'templates.order_items.price.label',
      contentValue: '{{ orderItem.price }}',
      description: 'templates.order_items.price.description',
    },
    {
      label: 'templates.order_items.description.label',
      contentValue: '{{ orderItem.description }}',
      description: 'templates.order_items.description.description',
    },
    {
      label: 'templates.order_items.account_number.label',
      contentValue: '{{ orderItem.account_number }}',
      description: 'templates.order_items.account_number.description',
    },
    {
      label: 'templates.order_items.analytic_code.label',
      contentValue: '{{ orderItem.analytic_code }}',
      description: 'templates.order_items.analytic_code.description',
    },
    {
      label: 'templates.order_items.tax_rate.label',
      contentValue: '{{ orderItem.tax_rate }}',
      description: 'templates.order_items.tax_rate.description',
    },
    {
      label: 'templates.order_items.credit_price.label',
      contentValue: '{{ orderItem.credit_price }}',
      description: 'templates.order_items.credit_price.description',
    },
    {
      label: 'templates.order_items.discount.label',
      contentValue: '{{ orderItem.discount }}',
      description: 'templates.order_items.discount.description',
    },
    {
      label: 'templates.order_items.discount_type.label',
      contentValue: '{{ orderItem.discount_type }}',
      description: 'templates.order_items.discount_type.description',
    },
  ],
  related: [],
  relatedInLoop: [],
};
